import { Fragment } from "react";
export default function Heading({ title, text, children }) {
  return (
    <div className="grid gap-2">
      <div className="flex items-center justify-between">
        <p className="text-lg font-semibold text-white">{title}</p>
        <div className="flex items-center space-x-6">{children}</div>
      </div>
      {text && (
        <Fragment>
          <hr className="hr" />
          <p className="text-xs text-stone-400">{text}</p>
        </Fragment>
      )}
    </div>
  );
}
